/**
 * Encode / Decode string
 */
import Helper from "./Helper";

const EncodeDecode = {
    setValue: function (str) {
        let randomString = Helper.randomString(25);
        return window.btoa(randomString + '###' + str + '###' + randomString);
    },
    getValue: function (str) {
        let strText = window.atob(str);
        let strArr = strText.split('###');
        strArr.shift(); // Remove first element of the array
        strArr.pop(); // Remove last element of the array
        return strArr;
    }
}

export default EncodeDecode;